import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from '../services/utils.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private utilsService: UtilsService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        switch (err.status) {
          case 403:
            // si es error de envio de informe no queremos que se muestre el error
            if (request.url.includes('tests/send/report')) {
              return throwError(err.error);
            }
            this.utilsService.toast('warning', 'SessionExpired');
            this.authenticationService.logOut('consultant');
            this.modalService.dismissAll();
            return throwError(err.error);

          case 500:
            // TODO: quitar if cuando consiga enviar otro status code en back
            if (
              err.error.message !== 'ya existe un proceso con ese nombre en esa oficina' ||
              err.error.message !== 'El candidato tiene una prueba pendiente para ese Jobtype.'
            ) {
              // this.router.navigateByUrl('/error');
            }

            if (err.error.message === 'No se encuentran los datos del candidato') {
              this.utilsService.toast('error', 'NoCandidateData', true, this.utilsService.getNacsData({ endpoint: 'ERROR INTERCEPTOR REQUEST:' + request, body: '', error: { err: err } }));
            }
            return throwError(err.error);

          default:
            return throwError(err.error);
        }
      })
    );
  }
}
